/* Filtra la galeria del PDP por color, replicando "StarApps Variant Image" SIN app.
   Regla (de StarApps): la galeria va por posicion; cada color ocupa desde su foto
   "featured" (la unica con variant image) hasta la featured del siguiente color.
   Al elegir color mostramos solo su grupo y ocultamos el resto con el atributo `hidden`
   (<slideshow-component> excluye de .slides las slides [hidden] -> carrusel/paginacion OK).
   Horizon REEMPLAZA <media-gallery> al cambiar variante; observamos el contenedor
   estable .product-information__media para re-filtrar al instante tras el re-render. */
(function () {
  var theMap = null, mapReady = false, mapLoading = false;

  function injectStyle() {
    if (document.getElementById('gallery-filter-style')) return;
    var st = document.createElement('style');
    st.id = 'gallery-filter-style';
    st.textContent =
      'media-gallery slideshow-slide[hidden],' +
      'media-gallery li[hidden],' +
      'media-gallery zoom-dialog .dialog-thumbnails-list button[hidden]{display:none !important;}';
    (document.head || document.documentElement).appendChild(st);
  }

  function buildMap(p) {
    if (!p || !p.options || !p.variants || !p.media) return { hasColor: false };
    var colorOpt = null, idx = 0;
    for (var i = 0; i < p.options.length; i++) {
      var o = p.options[i];
      var nm = (o && o.name) ? o.name : o;
      if (/colou?r/i.test(nm)) { colorOpt = o; idx = i; break; }
    }
    if (!colorOpt) return { hasColor: false };
    var pos = (colorOpt && colorOpt.position) ? colorOpt.position : (idx + 1);

    var colorFeatured = {};
    for (var v = 0; v < p.variants.length; v++) {
      var vr = p.variants[v];
      var c = vr['option' + pos];
      if (c && vr.featured_media && !(c in colorFeatured)) colorFeatured[c] = String(vr.featured_media.id);
    }
    var featuredToColor = {};
    for (var cc in colorFeatured) featuredToColor[colorFeatured[cc]] = cc;

    var media = p.media.slice().sort(function (a, b) { return a.position - b.position; });
    var color2ids = {}, orphans = [], cur = null;
    for (var m = 0; m < media.length; m++) {
      var id = String(media[m].id);
      if (featuredToColor[id]) cur = featuredToColor[id];
      if (cur) { (color2ids[cur] = color2ids[cur] || []).push(id); }
      else orphans.push(id);
    }
    return { hasColor: true, color2ids: color2ids, orphans: orphans };
  }

  function ensureMap() {
    if (mapReady || mapLoading) return;
    mapLoading = true;
    var mm = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!mm) { theMap = { hasColor: false }; mapReady = true; return; }
    fetch('/products/' + mm[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(buildMap)
      .catch(function () { return { hasColor: false }; })
      .then(function (m) { theMap = m; mapReady = true; applyNow(); });
  }

  function selectedColor() {
    var fs = document.querySelector(
      'variant-picker fieldset.variant-option--swatches, variant-picker fieldset.native-swatch-upgraded'
    );
    if (fs) {
      var inp = fs.querySelector('input:checked');
      if (inp) return inp.value || inp.getAttribute('aria-label');
    }
    return null;
  }

  // envoltorio a ocultar para un elemento con data-media-id (slide / li de grid / li de zoom)
  function wrapOf(holder) { return holder.closest('slideshow-slide, li'); }

  // las miniaturas del zoom son <button> sin data-media-id -> sincronizar por indice
  // con los <li> de la galeria ampliada (mismo orden).
  function syncZoomThumbs(mg) {
    var zli = mg.querySelectorAll('zoom-dialog ul.dialog-zoomed-gallery > li');
    var zbtn = mg.querySelectorAll('zoom-dialog .dialog-thumbnails-list button');
    if (zbtn.length && zbtn.length === zli.length) {
      for (var i = 0; i < zli.length; i++) {
        if (zbtn[i].hidden !== zli[i].hidden) zbtn[i].hidden = zli[i].hidden;
      }
    }
  }

  function applyNow() {
    if (!mapReady || !theMap || !theMap.hasColor) return;
    var color = selectedColor();
    if (!color) return;
    var mg = document.querySelector('media-gallery');
    if (!mg) return;
    var ids = theMap.color2ids[color];

    var holders = mg.querySelectorAll('[data-media-id]');

    // sin grupo para este color -> no filtrar (evita galeria vacia)
    if (!ids || !ids.length) {
      for (var u = 0; u < holders.length; u++) {
        var wu = wrapOf(holders[u]);
        if (wu && wu.hidden) wu.hidden = false;
      }
      syncZoomThumbs(mg);
      return;
    }

    var keep = {};
    ids.forEach(function (id) { keep[id] = 1; });
    (theMap.orphans || []).forEach(function (id) { keep[id] = 1; });

    for (var i = 0; i < holders.length; i++) {
      var holder = holders[i];
      var mid = holder.getAttribute('data-media-id');
      if (!mid) continue;
      var w = wrapOf(holder);
      if (!w) continue;
      var hide = !keep[mid];
      if (w.hidden !== hide) w.hidden = hide;
    }
    syncZoomThumbs(mg);
  }

  // re-aplicar (debounce por frame). El observer va en el contenedor ESTABLE.
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(function () {
      pending = false;
      applyNow();
    });
  }
  function observe() {
    var stable = document.querySelector('.product-information__media');
    if (!stable) { var g = document.querySelector('media-gallery'); stable = g && g.parentElement; }
    if (stable && !stable.dataset.gfObserved) {
      stable.dataset.gfObserved = '1';
      new MutationObserver(schedule).observe(stable, { childList: true, subtree: true });
    }
  }

  function run() { injectStyle(); ensureMap(); applyNow(); observe(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('variant:update', function () { schedule(); setTimeout(run, 60); });
  var tries = 0;
  var iv = setInterval(function () { run(); if (++tries > 8) clearInterval(iv); }, 350);
})();
